export default __webpack_public_path__ + "static/media/svg-3.d5bc818a.svg";